import { Helmet } from "react-helmet-async";
import { useMatches } from "react-router-dom";

const APP_TITLE = "ERP GOLD";

interface RouteHandle {
  title?: string;
}

export const RouteDocumentTitle = () => {
  const matches = useMatches();
  const routeTitle = [...matches]
    .reverse()
    .map((match) => (match.handle as RouteHandle | undefined)?.title)
    .find((title): title is string => Boolean(title));

  const title = routeTitle ? `${routeTitle} | ${APP_TITLE}` : APP_TITLE;

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
